<template>
  <div v-bind:class="{loading: isLoading}" id="search" class="columns">
    <div class="column is-three-quarters">
      <h2 class="subtitle">Search Results For: {{ searchTerm }}</h2>
      <div v-if="notification" class="notification is-info">
        <button @click="notification = ''" class="delete"></button>
        {{ notification }}
      </div>
      <table class="table">
        <thead>
          <tr>
            <th width="50"></th>
            <th width="75">Qty</th>
            <th class="clickable" width="75" @click="sortBy('available-quantity')">Avail</th>
            <th class="clickable" @click="sortBy('product-title')">Name</th>
            <th class="clickable" @click="sortBy('set-name')">Set</th>
            <th class="clickable" @click="sortBy('condition')">Cond</th>
            <th class="clickable" @click="sortBy('price')">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in orderedProducts">
            <td><button :disabled="p.quantity < 1 || p.quantity > p.available_quantity" @click.prevent="addToCart(p)" class="button is-primary"><i class="fa fa-cart-plus" aria-hidden="true"></i></button></td>
            <td><input class="input quantity" type="number" v-model.number="p.quantity"></td>
            <td>{{ p.available_quantity }}</td>
            <td><card-title :title="cardName(p.variant.id)" :image-url="p.image"></card-title></td>
            <td>{{ setName(p.variant.id) }}</td>
            <td>{{ p.variant.title }}</td>
            <td>${{ p.variant.price}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Client from 'shopify-buy';
import Raven from 'raven-js';
import CardTitle from './partials/CardTitle';
import { variantId } from '../shopify-ids';
import processProduct from '../process-product';

export default {
  name: 'BuySearch',
  data() {
    return {
      isLoading: false,
      category: {},
      products: [],
      checkout: {},
      client: null,
      searchTerm: null,
      cardDetails: [],
      notification: '',

      sortKey: '',
      sortDirection: 1, // -1 for reverse
    };
  },
  components: {
    'card-title': CardTitle,
  },
  computed: {
    orderedProducts() {
      if (!this.sortKey) {
        return this.products;
      }

      const sk = this.sortKey;
      const getValue = (k, o) => {
        if (k === 'available-quantity') {
          return o.available_quantity;
        } else if (k === 'product-title') {
          return o.variant.productTitle;
        } else if (k === 'set-name') {
          return this.setName(o.variant.id);
        } else if (k === 'condition') {
          return o.variant.title;
        } else if (k === 'price') {
          return Number(o.variant.formattedPrice.substr(1));
        }

        return '';
      };

      return this.products.sort((a, b) => {
        if (getValue(sk, a) < getValue(sk, b)) {
          return 1 * this.sortDirection;
        } else if (getValue(sk, a) > getValue(sk, b)) {
          return -1 * this.sortDirection;
        }

        return 0;
      });
    },
  },
  methods: {
    addToCart(p) {
      this.client.checkout.addLineItems(
        localStorage.getItem('shopifyCheckoutId'),
        [{ variantId: p.variant.id, quantity: p.quantity }],
      );

      const cd = this.cardDetails.find(d => variantId(d.variant_id) === p.variant.id);
      this.notification = `${cd.card_name} has been added to your shopping cart.`;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortDirection = this.sortDirection * -1;
    },
    cardName(v) {
      const cd = this.cardDetails.find(d => variantId(d.variant_id) === v);
      if (cd !== undefined) {
        return cd.card_name;
      }

      return '';
    },
    setName(v) {
      const cd = this.cardDetails.find(d => variantId(d.variant_id) === v);
      if (cd !== undefined) {
        return cd.set_name;
      }

      return '';
    },
    loadData(term) {
      if (term.length < 3) {
        return;
      }

      this.isLoading = true;
      this.products = [];

      this.axios.get(`https://inventory.powernine.com/shopify/variants?card_name=${term}`).then((response) => {
        this.cardDetails = response.data;
        return this.client.product.fetchMultiple(
          this.cardDetails.map(p => btoa(`gid://shopify/Product/${p.product_id}`)),
        );
      }).then((products) => {
        products.forEach(processProduct(this.cardDetails, this.products));

        return this.client.checkout.fetch(localStorage.getItem('shopifyCheckoutId'));
      }).then((checkout) => {
        this.checkout = checkout;
        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
        Raven.captureException(err);
        throw err;
      });
    },
  },
  mounted() {
    this.client = Client.buildClient({
      storefrontAccessToken: 'c532a34d42a102560faf84bbb93624f1',
      domain: 'powernine.myshopify.com',
      appId: '6',
    });

    new Promise((resolve) => {
      if (localStorage.getItem('shopifyCheckoutId')) {
        resolve(this.client.checkout.fetch(localStorage.getItem('shopifyCheckoutId')));
      }

      resolve(null);
    }).then((checkout) => {
      if (!checkout) {
        return this.client.checkout.create();
      }

      return checkout;
    }).then((checkout) => {
      localStorage.setItem('shopifyCheckoutId', checkout.id);
    }).then(() => {
      this.loadData(this.$route.query.card_name);
      this.searchTerm = this.$route.query.card_name;
    });
  },
  watch: {
    // eslint-disable-next-line
    '$route': function (to) {
      this.loadData(to.query.card_name);
    },
  },
};
</script>



// WEBPACK FOOTER //
// BuySearch.vue?4edfdfee